import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4ed8e913"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick, computed } from "vue";
import { useRouter } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import { operlogLogList, operlogLoginLog, delOperlog, cleanOperlog } from "@/api/system1/log";
import { download } from '@/utils/index';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const ruleFormRef = ref(ElForm);
    const uploadRef = ref();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '操作日志';
    });
    const state = reactive({
      // 当前页签名称
      activeName: '待发通知',
      // 遮罩层
      loading: true,
      saveLoading: false,
      chnageFlag: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 模型表格数据
      list: {
        total: 0,
        rows: []
      },
      // 表单参数
      form1: {
        "operId": 0,
        "title": "",
        "businessType": 0,
        "method": "",
        "requestMethod": "",
        "operatorType": 0,
        "operName": "",
        "deptName": "",
        "operUrl": "",
        "operIp": "",
        "operLocation": "",
        "operParam": "",
        "jsonResult": "",
        "status": 0,
        "errorMsg": "",
        "operTime": "",
        "tenantId": null,
        "costTime": 0
      },
      // 表格选中的数据
      currentSelectRows: [],
      // 查询参数
      queryParams: {
        pageSize: 10,
        pageNum: 1,
        startDate: '',
        endDate: '',
        originDate: [],
        userName: '',
        ipaddr: '',
        status: ''
      },
      uploadForm: {
        fileList: []
      },
      uploadFormRules: {
        fileList: [{
          required: true,
          message: "上传文件不能为空",
          trigger: "blur"
        }]
      },
      cloneQueryParams: null,
      searchFormData: [{
        prop: "operName",
        label: "用户账号",
        type: "text",
        placeholder: "请输入用户账号",
        span: 7
      }, {
        prop: "title",
        label: "模块标题",
        type: "text",
        placeholder: "请输入模块标题",
        span: 7
      }, {
        prop: "businessType",
        label: "业务类型",
        placeholder: "请选择业务类型",
        type: "list",
        isSelect: false,
        filterable: true,
        options: [{
          dictValue: 0,
          dictLabel: "其它"
        }, {
          dictValue: 1,
          dictLabel: "新增"
        }, {
          dictValue: 2,
          dictLabel: "修改"
        }, {
          dictValue: 3,
          dictLabel: "删除"
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 4
      }, {
        prop: "originDate",
        label: "操作时间",
        type: "daterange",
        multiple: true,
        span: 7,
        change: val => {
          if (val?.length) {
            state.queryParams.startDate = val[0] + ' 00:00:00';
            state.queryParams.endDate = val[1] + ' 23:59:59';
          } else {
            state.queryParams.startDate = '';
            state.queryParams.endDate = '';
          }
        }
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "Refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "导出",
        buttonStyle: "warning",
        hasPermi: ['system:operlog:export'],
        className: 'exportBtn',
        buttonIcon: "Upload",
        exp: item => handleExport(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['system:operlog:remove'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }, {
        buttonName: "清空",
        buttonStyle: "danger",
        hasPermi: ['system:operlog:remove'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleQingkong()
      }],
      tableHeader: [{
        prop: "index",
        label: "序号"
      }, {
        prop: "operName",
        label: "用户账号"
      }, {
        prop: "title",
        label: "模块标题"
      }, {
        prop: "operIp",
        label: "主机地址"
      }, {
        prop: "operDesc",
        label: "操作内容"
      }, {
        prop: "businessType",
        label: "业务类型",
        statusList: [{
          value: 0,
          label: "其它"
        }, {
          value: 1,
          label: "新增"
        }, {
          value: 2,
          label: "修改"
        }, {
          value: 3,
          label: "删除"
        }, {
          value: 4,
          label: "授权"
        }, {
          value: 5,
          label: "导出"
        }, {
          value: 6,
          label: "导入"
        }]
      }, {
        prop: "operatorType",
        label: "操作类别",
        statusList: [{
          value: 0,
          label: "其它"
        }, {
          value: 1,
          label: "后台用户"
        }, {
          value: 2,
          label: "手机端用户"
        }]
      }, {
        prop: "operTime",
        label: "操作时间"
      }, {
        prop: "operation",
        label: "操作",
        width: "150px",
        fixed: "right",
        operation: [{
          name: '查看',
          clickFun: row => handleLook(row),
          hasPermi: ['system:operlog:query']
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['system:operlog:remove']
        }]
      }],
      operation: '新增',
      //是否为编辑操作
      transName: '',
      transformer: '',
      // 表单参数
      form: {
        infoType: '',
        wechatGroupName: '',
        time: '是',
        releaseDateStr: '',
        infoCategory: '文字',
        fileUrl: '',
        fileRaw: null,
        releaseContent: '',
        remark: '',
        deptNames: '',
        courtsManageNames: ''
      },
      cloneForm: null,
      // 表单校验
      rules: {
        feeder: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        wechatGroupName: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        time: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        releaseDateStr: [{
          validator: (rule, value, callback) => {
            if (value) {
              if (new Date(value).getTime() <= new Date().getTime()) {
                callback(new Error('选择的时间不能小于当前时间！'));
              } else {
                callback();
              }
            } else {
              callback(new Error('不能为空'));
            }
          },
          trigger: "change"
        }],
        infoType: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        fileUrl: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        releaseContent: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }]
      },
      formData1: [{
        prop: "businessType",
        label: "业务类型（0其它 1新增 2修改 3删除）",
        placeholder: "",
        type: "list",
        isSelect: false,
        filterable: true,
        options: [{
          dictValue: 0,
          dictLabel: "其它"
        }, {
          dictValue: 1,
          dictLabel: "新增"
        }, {
          dictValue: 2,
          dictLabel: "修改"
        }, {
          dictValue: 3,
          dictLabel: "删除"
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 24
      }, {
        prop: "costTime",
        label: "消耗时间（毫秒）",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "deptName",
        label: "部门名称",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "errorMsg",
        label: "错误消息",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "jsonResult",
        label: "返回参数",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "method",
        label: "方法名称",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "operatorType",
        label: "操作类别",
        //（0其它 1后台用户 2手机端用户）
        placeholder: "",
        type: "list",
        isSelect: false,
        filterable: true,
        options: [{
          dictValue: 0,
          dictLabel: "其它"
        }, {
          dictValue: 1,
          dictLabel: "后台用户"
        }, {
          dictValue: 2,
          dictLabel: "手机端用户"
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 24
      }, {
        prop: "operId",
        label: "操作日志id",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "operIp",
        label: "主机地址",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "operLocation",
        label: "操作地点",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "operName",
        label: "用户账号",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "operParam",
        label: "请求参数",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "operTime",
        label: "操作时间",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "operUrl",
        label: "请求URL",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "requestMethod",
        label: "请求方式",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "status",
        label: "操作状态",
        //（0正常 1异常）
        placeholder: "",
        type: "list",
        isSelect: false,
        filterable: true,
        options: [{
          dictValue: 0,
          dictLabel: "正常"
        }, {
          dictValue: 1,
          dictLabel: "异常"
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 24
      }, {
        prop: "tenantId",
        label: "租户ID（多租户支持）",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "title",
        label: "模块标题",
        placeholder: "",
        type: "text",
        span: 24
      }],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      dialogVisible: false,
      dialogVisible1: false,
      typeUrl: ''
    });
    state.cloneQueryParams = JSON.parse(JSON.stringify(state.queryParams));
    state.cloneForm = JSON.parse(JSON.stringify(state.form));
    onMounted(() => {});
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.operId);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    // 清空
    const handleQingkong = function () {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认清空登录日志?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return cleanOperlog();
      }).then(res => {
        getList();
        ElMessage.success("清空成功");
      }).catch(function () {});
    };
    const handleLook = function (row) {
      state.dialogVisible1 = true;
      state.form1 = {
        ...row
      };
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const logIds = row.operId || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return delOperlog(logIds);
      }).then(res => {
        getList();
        ElMessage.success("删除成功");
      }).catch(function () {});
    };
    /** 导出文件 */
    const handleExport = function (row) {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认导出数据项?', "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        operlogLoginLog(state.queryParams).then(res => {
          if (res.status === 200) {
            let fileName = decodeURI(res.headers["content-disposition"].split("utf-8''")[1]);
            download(res.data, fileName);
          }
        }).catch(() => {});
      });
    };
    /** 查询列表 */
    const getList = function () {
      state.loading = true;
      let params = {
        ...state.queryParams
      };
      delete params.originDate;
      operlogLogList(params).then(res => {
        if (res.code == 0) {
          state.list = {
            rows: res.data.list,
            total: res.data.total
          };
        }
      }).finally(() => {
        state.loading = false;
      });
    };

    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.queryParams = JSON.parse(JSON.stringify(state.cloneQueryParams));
      handleQuery();
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "rizhifuwu",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className]),
          loading: item.loading,
          disabled: item.disabled,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "disabled", "icon", "type", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.list,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange,
        rowKey: "operId"
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.dialogVisible1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.dialogVisible1 = $event),
        size: "800px",
        title: "操作日志详情",
        "close-on-click-modal": false,
        onClose: _ctx.clearForm1
      }, {
        footer: _withCtx(() => []),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref: "formContainer1",
          form: state.form1,
          formData: state.formData1,
          isDetail: true,
          isHandle: false
        }, null, 8, ["form", "formData"])]),
        _: 1
      }, 8, ["modelValue", "onClose"])]);
    };
  }
};